import { render, staticRenderFns } from "./ShortDeliveryDetail.vue?vue&type=template&id=56600526&"
import script from "./ShortDeliveryDetail.vue?vue&type=script&lang=js&"
export * from "./ShortDeliveryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports